import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=56f6b5a4&scoped=true&"
import script from "./SideBarItem.vue?vue&type=script&lang=js&"
export * from "./SideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=56f6b5a4&prod&lang=less&"
import style1 from "./SideBarItem.vue?vue&type=style&index=1&id=56f6b5a4&prod&lang=less&scoped=true&"
import style2 from "./SideBarItem.vue?vue&type=style&index=2&id=56f6b5a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6b5a4",
  null
  
)

export default component.exports